module.exports = __webpack_public_path__ + "static/media/logo-haus-shiraz-white.9f7a95ea.svg";